import { c as _c } from "react/compiler-runtime";
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import IconDimensions from 'components/icons/IconDimensions';
import IconOpenClose from 'components/icons/IconOpenClose';
import { logError } from 'commons/logger';
import { colorGrayLight2 } from 'styles/layout/colors';
import { BUILD_YOUR_OWN_SOFA_LINK } from 'commons/constants';
import usePDPGalleryInteractedEvent from 'data-hooks/useEvents/usePDPGalleryInteractedEvent';
import { GALLERY_IMAGE_LOCATION, GALLERY_INTERACTION } from 'data-hooks/useEvents/pdpGalleryEventConstants';
import PDPDesktopHeroThumbnail from '../PDPDesktopHeroThumbnail';
import IconFourSquare from '../../../../icons/iconFourSquare';
const DEFAULT_DIMENSION_SHOT_URLS = [];
const DEFAULT_PHOTOS = [];
const PDPDesktopConfigThumbnails = t0 => {
  const $ = _c(43);
  const {
    isMechanicalOpen: t1,
    toggleMechanicalOpen,
    dimensionsImage,
    shouldShowDimensionThumbnail: t2,
    dimensionShotUrls: t3,
    enableCrops,
    isConfigFlipped: t4,
    isCylindoConfigurationPhotos: t5,
    loading: t6,
    onMeasureActivated,
    pdpIsModularBYOProduct: t7,
    photos: t8,
    selectedPhoto: t9,
    setSelectedPhoto,
    viewGalleryImageEvent
  } = t0;
  const isMechanicalOpen = t1 === undefined ? null : t1;
  const shouldShowDimensionThumbnail = t2 === undefined ? false : t2;
  const dimensionShotUrls = t3 === undefined ? DEFAULT_DIMENSION_SHOT_URLS : t3;
  const isConfigFlipped = t4 === undefined ? false : t4;
  const isCylindoConfigurationPhotos = t5 === undefined ? false : t5;
  const loading = t6 === undefined ? false : t6;
  const pdpIsModularBYOProduct = t7 === undefined ? false : t7;
  const photos = t8 === undefined ? DEFAULT_PHOTOS : t8;
  const selectedPhoto = t9 === undefined ? null : t9;
  const {
    trackGalleryInteracted
  } = usePDPGalleryInteractedEvent();
  const hasReportedMeasureRef = useRef(false);
  if (loading) {
    let t10;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = <div className="flex">{[0, 1, 2, 3, 4].map(_temp)}</div>;
      $[0] = t10;
    } else {
      t10 = $[0];
    }
    return t10;
  }
  const showDimensionThumbnail = shouldShowDimensionThumbnail ?? (!!dimensionsImage || dimensionShotUrls.length > 0);
  const numOfPhotosToShow = showDimensionThumbnail ? 5 : 6;
  let selectDimensions;
  let t10;
  let t11;
  let t12;
  if ($[1] !== enableCrops || $[2] !== isConfigFlipped || $[3] !== isCylindoConfigurationPhotos || $[4] !== isMechanicalOpen || $[5] !== numOfPhotosToShow || $[6] !== onMeasureActivated || $[7] !== pdpIsModularBYOProduct || $[8] !== photos || $[9] !== selectedPhoto || $[10] !== setSelectedPhoto || $[11] !== toggleMechanicalOpen || $[12] !== trackGalleryInteracted || $[13] !== viewGalleryImageEvent) {
    const photosToShow = photos.slice(0, numOfPhotosToShow);
    let t13;
    if ($[18] !== onMeasureActivated || $[19] !== setSelectedPhoto || $[20] !== trackGalleryInteracted) {
      t13 = () => {
        if (!hasReportedMeasureRef.current) {
          hasReportedMeasureRef.current = true;
          trackGalleryInteracted(GALLERY_INTERACTION.MEASURE_ACTIVATED);
          onMeasureActivated?.();
        }
        setSelectedPhoto?.({
          type: "dimensional",
          index: 0
        });
      };
      $[18] = onMeasureActivated;
      $[19] = setSelectedPhoto;
      $[20] = trackGalleryInteracted;
      $[21] = t13;
    } else {
      t13 = $[21];
    }
    selectDimensions = t13;
    t10 = "flex";
    if ($[22] !== isConfigFlipped || $[23] !== isMechanicalOpen || $[24] !== toggleMechanicalOpen || $[25] !== trackGalleryInteracted) {
      t11 = isMechanicalOpen != null && <PDPDesktopHeroThumbnail ariaLabel={isMechanicalOpen ? "Close recliner" : "Open recliner"} title={isMechanicalOpen ? "Close recliner" : "Open recliner"} ariaPressed={isMechanicalOpen} onClick={() => {
        if (!isMechanicalOpen) {
          trackGalleryInteracted(GALLERY_INTERACTION.OPEN_STATE_ACTIVATED);
        }
        toggleMechanicalOpen();
      }} isSelected={isMechanicalOpen} icon={<IconOpenClose width={30} height={30} color={colorGrayLight2} />} type="open-close" isConfigFlipped={isConfigFlipped} />;
      $[22] = isConfigFlipped;
      $[23] = isMechanicalOpen;
      $[24] = toggleMechanicalOpen;
      $[25] = trackGalleryInteracted;
      $[26] = t11;
    } else {
      t11 = $[26];
    }
    t12 = photosToShow.map((t14, index) => {
      const {
        id,
        src,
        fallbackSrc,
        cropData,
        type
      } = t14;
      return <PDPDesktopHeroThumbnail cropData={cropData} enableCrops={enableCrops} key={id} onClick={() => {
        setSelectedPhoto?.({
          type,
          id,
          index,
          src
        });
      }} onMouseEnter={() => {
        setSelectedPhoto?.({
          type,
          id,
          index,
          src
        });
        viewGalleryImageEvent({
          imageLocation: GALLERY_IMAGE_LOCATION.CONFIGURATION,
          imageFilename: src?.split("/").pop() || "",
          position: index,
          totalImages: photos.length
        });
      }} onLoadFailure={() => {
        if (isCylindoConfigurationPhotos) {
          if (index === 0) {
            logError(new Error("Cylindo failed to render fabric thumbnail"), {
              CYLINDO_RENDER: "thumbnail-fallback"
            }, {
              src
            });
          }
          return;
        }
        if (pdpIsModularBYOProduct && selectedPhoto === id) {
          let newType = "configuration";
          let newIndex = 0;
          if (index === 0) {
            if (photosToShow.length > 1) {
              newIndex = 1;
            } else {
              newType = "studio";
            }
          }
          setSelectedPhoto?.({
            type: newType,
            index: newIndex
          });
        }
      }} type="configuration" src={src} fallbackSrc={fallbackSrc} isSelected={pdpIsModularBYOProduct ? selectedPhoto === id : selectedPhoto === src} isConfigFlipped={isConfigFlipped} isCylindoPhoto={isCylindoConfigurationPhotos} />;
    });
    $[1] = enableCrops;
    $[2] = isConfigFlipped;
    $[3] = isCylindoConfigurationPhotos;
    $[4] = isMechanicalOpen;
    $[5] = numOfPhotosToShow;
    $[6] = onMeasureActivated;
    $[7] = pdpIsModularBYOProduct;
    $[8] = photos;
    $[9] = selectedPhoto;
    $[10] = setSelectedPhoto;
    $[11] = toggleMechanicalOpen;
    $[12] = trackGalleryInteracted;
    $[13] = viewGalleryImageEvent;
    $[14] = selectDimensions;
    $[15] = t10;
    $[16] = t11;
    $[17] = t12;
  } else {
    selectDimensions = $[14];
    t10 = $[15];
    t11 = $[16];
    t12 = $[17];
  }
  let t13;
  if ($[27] !== pdpIsModularBYOProduct || $[28] !== selectedPhoto || $[29] !== setSelectedPhoto) {
    t13 = pdpIsModularBYOProduct ? <PDPDesktopHeroThumbnail enableCrops={false} key="build-your-own" onClick={() => {
      setSelectedPhoto?.({
        type: "buildyourown",
        index: 0
      });
    }} onMouseEnter={() => {
      setSelectedPhoto?.({
        type: "buildyourown",
        index: 0
      });
    }} type="buildyourown" icon={<IconFourSquare />} isSelected={selectedPhoto === BUILD_YOUR_OWN_SOFA_LINK} /> : null;
    $[27] = pdpIsModularBYOProduct;
    $[28] = selectedPhoto;
    $[29] = setSelectedPhoto;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== dimensionsImage || $[32] !== isConfigFlipped || $[33] !== selectDimensions || $[34] !== selectedPhoto?.type || $[35] !== showDimensionThumbnail) {
    t14 = showDimensionThumbnail && <PDPDesktopHeroThumbnail key={dimensionsImage || "dimensions"} onClick={selectDimensions} onMouseEnter={selectDimensions} isSelected={selectedPhoto?.type === "dimensional"} icon={<IconDimensions width={24} height={24} color={colorGrayLight2} />} isConfigFlipped={isConfigFlipped} />;
    $[31] = dimensionsImage;
    $[32] = isConfigFlipped;
    $[33] = selectDimensions;
    $[34] = selectedPhoto?.type;
    $[35] = showDimensionThumbnail;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  if ($[37] !== t10 || $[38] !== t11 || $[39] !== t12 || $[40] !== t13 || $[41] !== t14) {
    t15 = <div className={t10}>{t11}{t12}{t13}{t14}</div>;
    $[37] = t10;
    $[38] = t11;
    $[39] = t12;
    $[40] = t13;
    $[41] = t14;
    $[42] = t15;
  } else {
    t15 = $[42];
  }
  return t15;
};
PDPDesktopConfigThumbnails.propTypes = {
  isMechanicalOpen: PropTypes.bool,
  toggleMechanicalOpen: PropTypes.func,
  dimensionsImage: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  shouldShowDimensionThumbnail: PropTypes.bool,
  dimensionShotUrls: PropTypes.arrayOf(PropTypes.object),
  enableCrops: PropTypes.bool,
  pdpIsModularBYOProduct: PropTypes.bool,
  isConfigFlipped: PropTypes.bool,
  isCylindoConfigurationPhotos: PropTypes.bool,
  loading: PropTypes.bool,
  onMeasureActivated: PropTypes.func,
  photos: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    src: PropTypes.string.isRequired,
    fallbackSrc: PropTypes.string
  })),
  selectedPhoto: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  setSelectedPhoto: PropTypes.func,
  viewGalleryImageEvent: PropTypes.func
};
export default PDPDesktopConfigThumbnails;
function _temp(idx) {
  return <PDPDesktopHeroThumbnail key={idx} loading={true} />;
}